module.exports = __webpack_public_path__ + "media/images/app/privacy-policy-113b9f2e502b9e491a44e20bfa550ab6.svg";